module.exports = __webpack_public_path__ + "static/img/office (8).53e801bd.jpg";